$(() => {
  
  // --- Section 1: Tab switching ---
  $(document).on('click', '.help-page--tab-link', function(event){
    event.preventDefault();
    $(this).addClass('js-tab-select').siblings().removeClass('js-tab-select');
    
    const tabTarget = $(this).attr('href');
    $(tabTarget).addClass('js-tab-select').siblings().removeClass('js-tab-select');
  });

  // --- Section 2: Unit conversion ---
  $(document).on('click', '.help-page--unit-change', function(event){
    event.preventDefault();
    const unitTarget = $(this).attr('data-unit'); 
    const $block = $(this).closest('.help-page--unit-block');

    $block.find('.js-unit-select').removeClass('js-unit-select'); 
    $block.find('[data-unit="' + unitTarget + '"]').addClass('js-unit-select');
  });

  // --- Section 3: Accordions ---
  $(document).on('click', '.help-page--slide--btn', function(){
    $(this).toggleClass('js-answer-open');
    if($(this).hasClass('js-answer-open')){
      $(this).next().slideDown(100, 'swing');
    } else {
      $(this).next().slideUp(100, 'swing');
    }
  });

  // --- Section 4: Video Controler ---
  $(document).on('click', '.help-page--fit-guide--video-controller', function() {
    const videoId = $(this).attr('data-video');
    const video = document.getElementById(videoId);
    
    if (video.paused) {
      video.play();
      $(this).find('.icon-video-play').show();
      $(this).find('.icon-video-pause').hide();
    } else {
      video.pause();
      $(this).find('.icon-video-play').hide();
      $(this).find('.icon-video-pause').show();
    }
  });
});